if (!customElements.get('eos1v-lens-picker')) {
  customElements.define('eos1v-lens-picker', class extends HTMLElement {
    connectedCallback() {
      this.selector = this.closest('product-variant-selector');
      if (!this.selector) return;
      this.lensIndex = Number(this.dataset.lensIndex);
      this.conditionIndex = Number(this.dataset.conditionIndex);
      this.variants = JSON.parse(this.selector.querySelector('[data-variants-json]').textContent);
      this.optionNames = JSON.parse(this.selector.querySelector('[data-options-with-values]').textContent).map(option => option.name);
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.formatPrice = new Intl.NumberFormat(this.dataset.locale || 'en-US', {
        style: 'currency',
        currency: this.dataset.currency || 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
      this.onChange = event => {
        this.updatePrices();
        if (this.contains(event.target) && event.target.matches('input[type="radio"]')) {
          this.details.open = false;
          this.summary.focus({ preventScroll: true });
        }
      };
      this.onOutsideClick = event => {
        if (!this.contains(event.target)) this.details.open = false;
      };
      this.onKeyDown = event => {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          this.details.open = false;
          this.summary.focus();
        }
      };
      this.selector.addEventListener('change', this.onChange);
      document.addEventListener('click', this.onOutsideClick);
      this.addEventListener('keydown', this.onKeyDown);
      this.updatePrices();
    }
    disconnectedCallback() {
      this.selector?.removeEventListener('change', this.onChange);
      document.removeEventListener('click', this.onOutsideClick);
      this.removeEventListener('keydown', this.onKeyDown);
    }
    updatePrices() {
      const checked = [...this.selector.querySelectorAll('input[type="radio"]:checked')];
      const condition = checked.find(input => input.name === this.optionNames[this.conditionIndex])?.value;
      const selected = checked.find(input => input.name === this.optionNames[this.lensIndex])?.value;
      const base = this.variants.find(variant => variant.options[this.conditionIndex] === condition && variant.options[this.lensIndex] === this.dataset.bodyValue);
      if (!base) return;
      for (const input of this.querySelectorAll('input[type="radio"]')) {
        const variant = this.variants.find(item => item.options[this.conditionIndex] === condition && item.options[this.lensIndex] === input.value);
        if (!variant) continue;
        const amount = '+' + this.formatPrice.format((variant.price - base.price) / 100);
        input.closest('label').querySelector('[data-lens-price]').textContent = amount;
        if (input.value === selected) {
          this.querySelector('[data-lens-selected-name]').textContent = input.value;
          this.querySelector('[data-lens-selected-price]').textContent = amount;
        }
      }
    }
  });
}
